import { render, staticRenderFns } from "./CreatePolicyModal.vue?vue&type=template&id=8c2342a2&"
import script from "./CreatePolicyModal.vue?vue&type=script&lang=js&"
export * from "./CreatePolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports